/**
 * 商談 stage を日本語ラベル + 色付きバッジで表示する共通コンポーネント。
 * 顧客一覧の最新ステータス列・顧客詳細の商談タブで利用。
 */
import type { DealStage } from '@goenhub/shared';

import { Badge, type BadgeProps } from '@/components/ui/badge';

const STAGE_LABEL: Record<DealStage, string> = {
  document_requested: '資料請求',
  briefing: '個別説明',
  quote: '見積',
  won: '成約',
  agreed: '同意',
  paid: '入金',
  ordered: '発注',
  delivered: '納品',
  lost: '失注',
};

const STAGE_VARIANT: Record<DealStage, BadgeProps['variant']> = {
  document_requested: 'default',
  briefing: 'review',
  quote: 'draft',
  won: 'accent',
  agreed: 'accent',
  paid: 'approved',
  ordered: 'sent',
  delivered: 'approved',
  lost: 'danger',
};

interface Props {
  stage: DealStage | null | undefined;
  /** stage 未設定時に表示するプレースホルダ（既定: "—"） */
  placeholder?: string;
}

export function DealStageBadge({ stage, placeholder = '—' }: Props) {
  if (!stage) return <span className="text-[var(--text-muted)] text-xs">{placeholder}</span>;
  return <Badge variant={STAGE_VARIANT[stage]}>{STAGE_LABEL[stage]}</Badge>;
}

export function getDealStageLabel(stage: DealStage): string {
  return STAGE_LABEL[stage];
}
